import { cn } from '@/lib/utils';

import type { ChildProgress } from '@littlebird/action-cards';

// The row's count of the cards under it that are done, such as "1/3". A single subtask shows under its row, so
// "0/1" would say nothing more
export const FeedSubtasksChip = ({
  progress: { done, total },
}: {
  progress: ChildProgress;
}) =>
  total <= 1 ? null : (
    <span
      data-testid="feed-row-subtasks"
      aria-label={`${done} of ${total} subtasks done`}
      className={cn(
        'shrink-0 whitespace-nowrap text-[length:calc(12*var(--ac-u))] tabular-nums',
        done === total ? 'text-kind-done' : 'text-foreground-muted'
      )}
    >
      {`${done}/${total}`}
    </span>
  );
